import { CUBEJS_URL } from "../constants/constants";
import { getService, getAxiosHeaders } from "../../library/RestAPI";
import { getAppDateTimeRange } from "../../components/common/utilities";
import { getCubejsApi , redirectToLogin} from "../../components/common/Dashboard/cubejs-util";

export async function fetchDMContentTabSensitivityFields(
  queryString,
  queryTypeString,
  dimensionName
) {
  const gteTime = String(
    Date.parse(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))
  );
  const lteTime = String(Date.now());
  const gteTimeFilter = {
    dimension: `${dimensionName}.creationTime`,
    operator: "gte",
    values: [gteTime],
  };
  const lteTimeFilter = {
    dimension: `${dimensionName}.creationTime`,
    operator: "lte",
    values: [lteTime],
  };
  if (!queryString.filters) {
    queryString["filters"] = [];
  }
  // queryString.filters.push(gteTimeFilter);
  // queryString.filters.push(lteTimeFilter);

  const options = {
    method: "POST",
    url: `${CUBEJS_URL}/load?queryType=${queryTypeString}`,
    data: { query: queryString },
    headers: getAxiosHeaders(true),
  };

  const response = await getService(options);
  if (response && response.data) {
    return response.data;
  }
}

export async function fetchDMContentTabAllFields(
  queryString,
  queryTypeString,
  dimensionName
) {
  const gteTime = String(
    Date.parse(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))
  );
  const lteTime = String(Date.now());
  const gteTimeFilter = {
    dimension: `${dimensionName}.creationTime`,
    operator: "gte",
    values: [gteTime],
  };
  const lteTimeFilter = {
    dimension: `${dimensionName}.creationTime`,
    operator: "lte",
    values: [lteTime],
  };
  if (!queryString.filters) {
    queryString["filters"] = [];
  }
  // queryString.filters.push(gteTimeFilter);
  // queryString.filters.push(lteTimeFilter);

  const options = {
    method: "POST",
    url: `${CUBEJS_URL}/load?queryType=${queryTypeString}`,
    data: { query: queryString },
    headers: getAxiosHeaders(true),
  };

  const response = await getService(options);
  if (response && response.data) {
    return response.data;
  }
}

export async function fetchDMContentTabChildNodes(
  queryString,
  queryTypeString,
  dimensionName
) {
  const cubejsApi = getCubejsApi();
  const gteTime = String(
    Date.parse(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))
  );
  const lteTime = String(Date.now());
  const gteTimeFilter = {
    dimension: `${dimensionName}.creationTime`,
    operator: "gte",
    values: [gteTime],
  };
  const lteTimeFilter = {
    dimension: `${dimensionName}.creationTime`,
    operator: "lte",
    values: [lteTime],
  };
  if (!queryString.filters) {
    queryString["filters"] = [];
  }
  // queryString.filters.push(gteTimeFilter);
  // queryString.filters.push(lteTimeFilter);

  const options = {
    method: "GET",
    url: `${CUBEJS_URL}/load?query=${encodeURIComponent(
      JSON.stringify(queryString)
    )}&queryType=${queryTypeString}`,
    headers: getAxiosHeaders(true),
  };
  try {
    const resultSet = await cubejsApi.load(queryString);
    const response = resultSet.rawData();
    if (response) {
      return response;
    }
  } catch (error) {
    redirectToLogin(error)
  }
}
export async function fetchCubeDataSources(
  queryString,
  queryTypeString,
  dimensionName
) {
  if (!queryString.filters) {
    queryString["filters"] = [];
  }

  const options = {
    method: "POST",
    url: `${CUBEJS_URL}/load?queryType=${queryTypeString}`,
    data: { query: queryString },
    headers: getAxiosHeaders(true),
  };

  const response = await getService(options);
  if (response && response.data) {
    return response.data;
  }
}

export async function fetchDMContentTabAllTables(
  queryString,
  queryTypeString,
  dimensionName
) {
  const gteTime = String(
    Date.parse(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))
  );
  const lteTime = String(Date.now());
  const gteTimeFilter = {
    dimension: `${dimensionName}.creationTime`,
    operator: "gte",
    values: [gteTime],
  };
  const lteTimeFilter = {
    dimension: `${dimensionName}.creationTime`,
    operator: "lte",
    values: [lteTime],
  };
  if (!queryString.filters) {
    queryString["filters"] = [];
  }
  // queryString.filters.push(gteTimeFilter);
  // queryString.filters.push(lteTimeFilter);

  const options = {
    method: "POST",
    url: `${CUBEJS_URL}/load?queryType=${queryTypeString}`,
    data: { query: queryString },
    headers: getAxiosHeaders(true),
  };

  const response = await getService(options);
  if (response && response.data) {
    return response.data;
  }
}

export async function fetchDMContentTabDatabaseManagementFields(
  queryString,
  queryTypeString,
  dimensionName
) {
  const gteTime = String(
    Date.parse(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))
  );
  const lteTime = String(Date.now());
  const gteTimeFilter = {
    dimension: `${dimensionName}.creationTime`,
    operator: "gte",
    values: [gteTime],
  };
  const lteTimeFilter = {
    dimension: `${dimensionName}.creationTime`,
    operator: "lte",
    values: [lteTime],
  };
  if (!queryString.filters) {
    queryString["filters"] = [];
  }
  // queryString.filters.push(gteTimeFilter);
  // queryString.filters.push(lteTimeFilter);

  const options = {
    method: "POST",
    url: `${CUBEJS_URL}/load?queryType=${queryTypeString}`,
    data: { query: queryString },
    headers: getAxiosHeaders(true),
  };

  const response = await getService(options);
  if (response && response.data) {
    return response.data;
  }
}

export async function fecthAllDataSources(queryString, queryTypeString) {
  if (!queryString.filters) {
    queryString["filters"] = [];
  }
  const url = `${CUBEJS_URL}/load?query=${encodeURIComponent(
    JSON.stringify(queryString)
  )}&queryType=${queryTypeString}`;
  const options = {
    method: "GET",
    url: url,
    headers: getAxiosHeaders(true),
  };

  const response = await getService(options);
  if (response) {
    return response;
  }
}
